// src/pages/GuestLoginPage.jsx
import { Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

const ThankYouPage = () => {
  const { t } = useTranslation("common");

  return (
    <>
        <Box
            component="img"
            src="/images/new_patient.png"
            alt="Patient"
            sx={{ width: "100%", height: "auto", borderRadius: 3 }}
        />
        <Typography variant="body1" sx={{ flexGrow: 1, marginBottom: "0rem" }}>
            {t('guests.messages.thanks')}
        </Typography>
        <Typography variant="h3" sx={{ flexGrow: 1, marginBottom: "0rem" }}>
            {t('guests.messages.nice_day')}
        </Typography>
    </>
  );
};

export default ThankYouPage;